import React from 'react';

import { getTellusClientId } from '../../api';
import { readDiscoveryTheme } from '../../lib/discoveryThemes';

const staging = 'https://api.telluswhenwhere.com';
const docsLinks = [
  { label: 'Swagger UI', path: '/docs' },
  { label: 'OpenAPI JSON', path: '/openapi.json' }
];

function getApiBase() {
  return (process.env.REACT_APP_API_BASE || staging).replace(/\/+$/, '');
}

export const ApiDocsPage = () => {
  const activeTheme =
    typeof window === 'undefined' ? 'wildlife' : readDiscoveryTheme(window.location.search);
  const apiBase = getApiBase();

  return (
    <div className="atlas-route-shell">
      <section className="atlas-page-header">
        <div className="atlas-detail-stack">
          <span>
            <strong>API docs</strong>
            <span>Tellus runtime contract</span>
          </span>
        </div>
        <h1>Use the live Tellus API schema from the product shell.</h1>
        <p>
          Species, hotspots, events, checklists, and wildlife-context lanes now have a stable docs entry from the same
          UI where planning and discovery happen.
        </p>
      </section>

      <section className="atlas-detail-page">
        <div className="atlas-mini-stats">
          <div>
            <strong>{activeTheme}</strong>
            <span>Active theme</span>
          </div>
          <div>
            <strong>{docsLinks.length}</strong>
            <span>Live contract surfaces</span>
          </div>
          <div>
            <strong>{getTellusClientId().slice(0, 8)}</strong>
            <span>Client id seed</span>
          </div>
        </div>

        <div className="atlas-link-card-grid">
          {docsLinks.map((link) => (
            <a
              key={link.path}
              className="atlas-resource-card"
              href={`${apiBase}${link.path}`}
              rel="noreferrer"
              target="_blank"
            >
              <strong>{link.label}</strong>
              <span className="atlas-card-copy">{`${apiBase}${link.path}`}</span>
            </a>
          ))}
        </div>

        <div className="atlas-detail-grid">
          <div className="atlas-upcoming-card">
            <h4>Configured runtime</h4>
            <p className="atlas-card-copy">{apiBase}</p>
          </div>
          <div className="atlas-upcoming-card">
            <h4>What to recheck</h4>
            <p className="atlas-card-copy">
              Refresh these docs whenever periodic sweeps, observation ingest, planner payloads, or event-chain outputs
              shift shape upstream.
            </p>
          </div>
        </div>

        <div className="atlas-detail-note">
          Keep this page pointed at the runtime API so field operators can verify contracts without leaving the main
          Tellus shell.
        </div>
      </section>
    </div>
  );
};
